import React, { Component } from "react";
import PropTypes from "prop-types";
import { CasesByPOEntityTypeChart } from "../analytics/case-level/charts";

class PetitionsFiled extends Component {
  static propTypes = {
    year: PropTypes.number.isRequired
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { year } = this.props;
    const q = {
      up_industry: "T",
      filing_date: `${year}-01-01--${year}-12-31`
    };
    return (
      <React.Fragment>
        <h2>{`${year}: High Tech PTAB Patent Owners`}</h2>
        <CasesByPOEntityTypeChart query={q} height={500} />
      </React.Fragment>
    );
  }
}

export default PetitionsFiled;
